import { Container } from "../Container/container";
import "./weather.css";

export const Weather = ({ weatherData, onDelete }) => {
  const date = new Date();
  const day = date.toLocaleDateString("en-US", { weekday: "long" });

  if (!weatherData) return null;

  return (
    <section>
      <Container>
        <div className="weather">
          <div className="weather__cards">
            <div className="weather__card">

              <div className="weather__names">
                <p className="weather__name">{weatherData.name}</p>
                <p className="weather__name">{weatherData.sys.country}</p>
              </div>

              <h3 className="weather__hour">{date.getHours()}:00</h3>

              <button className="weather__button">Hourly forecast</button>

              <div className="weather__dates">
                <p className="weather__date">{date.toLocaleDateString()}</p>
                <p className="weather__date">{day}</p>
              </div>

              <img
                className="weather__sun"
                src={`https://openweathermap.org/img/wn/${weatherData.weather[0].icon}@2x.png`}
                alt=""
              />

              <h2 className="weather__temp">
                {Math.round(weatherData.main.temp)}°C
              </h2>

              <div className="weather__buttons">
                <input id="toggle-heart" type="checkbox" />
<label htmlFor="toggle-heart" aria-label="like">❤</label>

                <button
                  aria-label="Delete item"
                  className="delete-button"
                  onClick={() => onDelete(weatherData.id)}
                >
                  <svg
                    className="trash-svg"
                    viewBox="0 -10 64 74"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="trash-can">
                      <rect x="16" y="24" width="32" height="30" rx="3" ry="3" fill="#e2264d"></rect>
                      <g transform-origin="12 18" id="lid-group">
                        <rect x="12" y="12" width="40" height="6" rx="2" ry="2" fill="#e2264d"></rect>
                        <rect x="26" y="8" width="12" height="4" rx="2" ry="2" fill="#e2264d"></rect>
                      </g>
                    </g>
                  </svg>
                </button>
              </div>

            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};